import { HTMLAttributes, ReactNode } from 'react';
import styles from './styles.module.scss';

export type ScreenReaderOnlyProps = HTMLAttributes<HTMLDivElement> & {
  children: ReactNode;
};

export const ScreenReaderOnly = ({ children }: ScreenReaderOnlyProps) => (
  <div role="none" className={styles.screenReaderOnly}>
    {children}
  </div>
);

ScreenReaderOnly.displayName = 'ScreenReaderOnly';
